import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable, map, startWith } from 'rxjs';
import { NotificationService } from '../../notifications/shared/notification.service';
import { ContractService } from '../../shared/contract.service';
import { UserService } from 'src/app/shared/user.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CustomerService } from 'src/app/shared/shared/customer.service';
import { Table } from 'primeng/table';
import * as FileSaver from 'file-saver';
import { Contract, Created } from '../../shared/contract.model';
interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrl: './search-result.component.scss'
})

export class SearchResultComponent implements AfterViewInit {
searchForm :any = FormGroup;
actionType:any =["Created By","Approved By","Updated By","Rejected By"]
isLoading: boolean = false;
id: string;
mode: string;
isNotFound: boolean = false;
contractTypes: any;
filteredOptions: Observable<string[]>;
defaultAttributes: any = ["Contract Id", "Contract Name", "Contract Status"];
metaData: any =[];
formLoading = false;
transactions: [] = [];
obligationTypes: [] = [];
allUsers :[]=[];
contractStatus: []=[];
selectedValues: any[] = [];
selectedContract!: Contract[];

Created!: Created[];

statuses!: any[];
cols!: Column[];
contractList !:Contract [];

selectedColumns!: Column[];

loading: boolean = true;
;
  activityValues: number[] = [0, 100];
readonly separatorKeysCodes = [ENTER, COMMA] as const;
dataSource = new MatTableDataSource<any>();
@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;
displayedColumns: string[] = [
  "Contract Type", "Contract Name", "Party Name", "Start Date", "End Date", "Total Agreement Value", "Contract Status"
];


constructor( 
  private formBuilder: FormBuilder,
  private route: ActivatedRoute,
  public service: NotificationService,
 private contractService: ContractService,
 private userService :UserService,
 private customerService :CustomerService,
 private cd: ChangeDetectorRef){
  this.route.params.subscribe(params => {
    this.id = params['id'];
    this.mode = params['mode'];
  });
 
// this.searchForm = this.formBuilder.group({
//   contractTypeName: [],
//   contractStatus:[],
//   transactionTypeId:[],
//   entitlementTypeId:[],
//   obligationStatus:[],
//   action:[],
//   users:[],
//   metaData:[],
//   startDate:[],
//   endDate:[]
// })

// this.filteredOptions = this.searchForm.get('contractTypeName').valueChanges.pipe(
//   startWith(''),
//   map((value: string) => this._filter(value))
// );



}
async ngOnInit() {
this.getContract()

this.Created = [
    { name: 'Pankaj Jagdaley' },
    { name: 'Namrata Pandit' },
    { name: 'Satyam Joshi'},
];

this.statuses = [
    { label: 'Initiated', value: 'Initiated' },
    { label: 'Pending Approval', value: 'Pending Approval' },
    { label: 'Approved', value: 'Approved' },
    {label:'Rejected',value:'Rejected'},
    {label:'Pending Signature',value:'Pending Signature'},
    {label:'Signed',value:'Signed'},
    {label:'Archived',value:'Archived'},
    {label:'Review Pending',value:'Review Pending'},
    {label:'Reviewed',value:'Reviewed'},
    {label:'Expired',value:'Expired'}
];
}
clear(table: Table) {
  table.clear();
}
ngAfterViewInit(): void {

}
reset() {
  this.searchForm.reset();
}

async getContract() {
  await this.contractService.getAllContracts().then((allContracts: any) => {
   this.contractList = allContracts;
   this.loading = false;
   this.contractList.forEach((res) => (res.createDate = new Date(<Date>res.createDate)));
   this.contractList.forEach((res) => (res.updateDate = new Date(<Date>res.updateDate)));
      allContracts.filter((val: any) => {
        return this.userService.permissionsValue[
          "_CONTRACT_" + val.contractType.toUpperCase() + "_VIEW_"
        ];
      });
  });
 
}

getSeverity(status: string) {
  switch (status) {
      case 'unqualified':
          return 'danger';

      case 'qualified':
          return 'success';

      case 'new':
          return 'info';

      case 'negotiation':
          return 'warning';

      case 'renewal':
          return null;
  }
}

exportExcel() {
  import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.contractList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'customers');
  });
}

saveAsExcelFile(buffer: any, fileName: string): void {
  let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  let EXCEL_EXTENSION = '.xlsx';
  const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
  });
  FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
}


}

